export const TEMPLATE_WIDTH = '1512px';
